import React, { Component } from "react";
import NavTab from "../../../components/common/global_layout/navTab2";
import AdvencedSearchVols from "../../../components/common/Vols/advancedSearchVols";
import { Container, Col, Row, Form } from "reactstrap";
import HeadMobile from "../../../components/common/global_layout/carouselMobile";
import NavTabMobile from "../../../components/common/global_layout/navtabMobile";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import BasicFilter from "../../../components/common/Vols/basicFilter"
import ExtraParams from "../../../components/common/Vols/extraParams";
import { addMultiDest, multiDest, removeMultiDest } from "../../../slices/volSearchBarSlice";
import Promotions from "./promotions";
require("bootstrap");

class Vols extends Component {
  constructor(props) {
    super(props);
    this.state={
      nbCity :1,
      searchBars:[]
    }
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  onFormSubmit(evt) {
    evt.preventDefault();
    const volPr = this.props.vol
    const abstr = this.props.vol[0]
    const volReturn = this.props.basicFilter.volReturn
    const volClass = this.props.basicFilter.volClass
    let departCode = "",arriveCode="";
    volPr.forEach(e => {
      departCode = departCode + "," +e.departCode
      arriveCode = arriveCode + "," +e.arriveCode
    });
    departCode = departCode.substring(1,departCode.length)
    arriveCode = arriveCode.substring(1,arriveCode.length)
    if (this.props.startDate) {
      this.props.history.push(
        `/vols/search?multi=${this.props.multiDest}&return=${volReturn}&vol_class=${volClass}&max_stopovers=${1}&depart=${departCode}&arrive=${arriveCode}&date_depart=${this.props.startDate}&date_arrive=${this.props.endDate}&adults=1&children=0&infants=0&price_from=1&price_to=1000&adult_hand_bag=0&adult_hold_bag=0`
      );
    } else alert("select a valid date");
  }

  addCity(){
    this.setState({
      nbCity : this.state.nbCity+1
    })
    this.props.dispatch(addMultiDest(this.state.nbCity))
  }

  removeCity(){
    this.setState({
      nbCity : this.state.nbCity - 1
    })
    this.props.dispatch(removeMultiDest(this.state.nbCity))
  }
  createSearchBars(n){
    var bar = [];
    for(let i =0; i < n; i++){
        bar.push(<AdvencedSearchVols key={i} num={i+1}/>);
    }
    return bar;
}
  render() {
    const  multipleCity = this.props.multiDest
    return (
      <>
        <Container>
          <NavTab />
        </Container>

        <HeadMobile />

        <center>
          <h3 className="title-vol">TROUVER VOTRE VOL ICI</h3>
        </center>

        <Container>
          <NavTabMobile page="VOLS" width="100px" />
          <Form
            onSubmit={this.onFormSubmit.bind(this)}
            className="needs-validation"
          >
            <Col>
            <BasicFilter/>
            </Col>

              
              <AdvencedSearchVols num={0} />
            {
              this.createSearchBars(multipleCity)
            }

            
            
            <ExtraParams />
                    
          <Col>
          <div className="d-flex">
          {multipleCity !== -1 && multipleCity <= 2 && <div onClick={this.addCity.bind(this)}><div className="add_des mb-2">+ Ajouter un autre vol</div></div>}
          {multipleCity !== -1 && multipleCity >= 1 && <div className="ml-auto" onClick={this.removeCity.bind(this)}><div className="add_des mb-2">- suprimmer un vol</div></div>}

          </div>
          </Col>
            <Row className="mx-3 mt-2">
              <button className="search-button-vol ">
                <div
                  type="submit"
                  // onClick={this.onFormSubmit.bind(this)}
                >
                  Trouver un vol
                  <img
                    src="/imgs/navebar/search.svg"
                    id="search-icon-vol"
                    alt="Vol"
                  />
                </div>
              </button>
            </Row>
          </Form>
          <br />
          <br />
          <Promotions/>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    startDate: state.date.startDate,
    endDate: state.date.endDate,
    vol: state.volBarFilter.volFilter,
    multiDest:state.volBarFilter.multiDest,
    basicFilter : state.volBarFilter


  }
}
export default withRouter(connect(mapStateToProps)(Vols));
